/* 47X · PACK 6 DSX47 · armador de tallas y compra directa · ES5
   ────────────────────────────────────────────────────────────────────────
   Reglas que se cumplen aquí:
     · el pack son SEIS prendas fijas; lo que se arma es la talla de cada una
     · el CTA no se desbloquea hasta que las seis tienen talla
     · una sola línea en el carrito, una sola unidad, con las 12 propiedades
     · doble clic no agrega dos veces (candado `ocupado`)
     · si el AJAX falla, se avisa; NUNCA se manda al checkout a ciegas

   Rendimiento: el carrusel de cada card es scroll nativo con snap; los puntos
   se actualizan con un IntersectionObserver compartido, no con scroll listeners.
   Nada que dispare layout por frame.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-p6x47]');
  if (!raiz) return;

  var cfg;
  try { cfg = JSON.parse(raiz.querySelector('[data-p6x47-cfg]').textContent); }
  catch (e) { return; }

  var cards = raiz.querySelectorAll('[data-p6x47-card]');
  var barra = raiz.querySelector('[data-p6x47-prog]');
  var num = raiz.querySelector('[data-p6x47-prog-n]');
  var cta = raiz.querySelector('[data-p6x47-cta]');
  var aviso = raiz.querySelector('[data-p6x47-aviso]');
  var sticky = raiz.querySelector('[data-p6x47-sticky]');
  var stickyCta = sticky ? sticky.querySelector('[data-p6x47-cta-s]') : null;
  var ocupado = false;

  function dinero(cent, forzarDec) {
    var n = (Number(cent) || 0) / 100;
    var f = cfg.formato || '${{amount}}';
    var conDec = forzarDec || (n % 1 !== 0);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (todo, k) {
      var coma = k.indexOf('comma_separator') !== -1;
      var s = n.toFixed(conDec ? 2 : 0);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, coma ? '.' : ',');
      return p.length > 1 ? p[0] + (coma ? ',' : '.') + p[1] : p[0];
    });
  }
  /* Canal nativo de Shopify con prefijo 47x:. El dataLayer suelto no lo leía
     nadie en esta tienda. Ev47 lo publica por los dos lados. */
  function evento(nombre, extra) {
    var d = { item_name: cfg.nombre, value: cfg.precio / 100, currency: cfg.moneda || 'MXN' };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k]; } }
    try { if (window.Ev47) window.Ev47.pub(nombre, d); } catch (e) {}
  }
  function eventoUnaVez(nombre, extra) {
    var d = { item_name: cfg.nombre };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k]; } }
    try { if (window.Ev47) window.Ev47.unaVez(nombre, d); } catch (e) {}
  }

  /* ── puntos del carrusel · un solo observador para todas las fotos ───── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ent) {
      for (var i = 0; i < ent.length; i++) {
        if (!ent[i].isIntersecting) continue;
        var img = ent[i].target;
        var caja = img.parentNode;
        var pts = caja.parentNode.querySelectorAll('[data-p6x47-punto]');
        var idx = Array.prototype.indexOf.call(caja.children, img);
        for (var j = 0; j < pts.length; j++) pts[j].classList.toggle('is-on', j === idx);
      }
    }, { root: null, threshold: 0.55 });
    var fotos = raiz.querySelectorAll('[data-p6x47-fotos] img');
    for (var f = 0; f < fotos.length; f++) io.observe(fotos[f]);
  }

  /* ── selección de tallas ───────────────────────────────────────────────── */
  function elegidas() {
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var b = cards[i].querySelector('.p6x47__talla.is-on');
      out.push(b ? b.getAttribute('data-p6x47-talla') : null);
    }
    return out;
  }

  function pinta() {
    var e = elegidas();
    var listas = 0;
    for (var i = 0; i < e.length; i++) {
      if (e[i]) listas++;
      cards[i].classList.toggle('is-listo', !!e[i]);
    }
    var total = cards.length;
    if (barra) barra.style.width = (listas / total * 100) + '%';
    if (num) num.textContent = listas + '/' + total;

    var completo = listas === total;
    if (cta) {
      cta.disabled = !completo;
      cta.textContent = completo
        ? cfg.cta_listo.replace('{precio}', dinero(cfg.precio))
        : cfg.cta_falta.replace('{n}', String(total - listas));
    }
    if (aviso && completo) { aviso.textContent = ''; aviso.classList.remove('is-mal'); }

    /* una sola vez cada uno, por carga */
    if (listas > 0) eventoUnaVez('pack_started', { piezas: total });
    if (completo) eventoUnaVez('pack_completed', { piezas: total, tallas: e.join(',') });

    return { e: e, completo: completo, listas: listas };
  }

  raiz.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-p6x47-talla]') : null;
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    var card = btn.closest('[data-p6x47-card]');
    if (!card) return;
    var hermanos = card.querySelectorAll('[data-p6x47-talla]');
    for (var i = 0; i < hermanos.length; i++) {
      var on = hermanos[i] === btn;
      hermanos[i].classList.toggle('is-on', on);
      hermanos[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (modoSimple) marcaFichas('');
    pinta();
  }, false);

  /* ── agregar ──────────────────────────────────────────────────────────── */
  /* El pack tiene variantes de talla propias, pero aquí cada prenda lleva la
     suya. Para que la línea del pedido no diga una talla al azar se elige la
     que más se repite; las seis van explícitas en las propiedades, que son
     las que manda la producción. */
  function varianteDelPack(sizes) {
    var cuenta = {}, mejor = null, max = 0;
    for (var i = 0; i < sizes.length; i++) {
      cuenta[sizes[i]] = (cuenta[sizes[i]] || 0) + 1;
      if (cuenta[sizes[i]] > max) { max = cuenta[sizes[i]]; mejor = sizes[i]; }
    }
    return (cfg.variantes && cfg.variantes[mejor]) || cfg.variante_defecto;
  }

  function comprar() {
    var st = pinta();
    if (!st.completo) {
      if (aviso) {
        aviso.textContent = 'Te faltan ' + (cards.length - st.listas) + ' tallas por elegir';
        aviso.classList.add('is-mal');
      }
      var falta = null;
      for (var i = 0; i < cards.length; i++) { if (!st.e[i]) { falta = cards[i]; break; } }
      if (falta) falta.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (ocupado) return;
    ocupado = true;
    if (cta) cta.disabled = true;

    var props = {};
    for (var k = 0; k < cards.length; k++) {
      var n = k + 1;
      props['Diseño ' + n] = cards[k].getAttribute('data-p6x47-nombre');
      props['Talla ' + n] = st.e[k];
    }

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(varianteDelPack(st.e)), quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function () {
      evento('pack_added_to_cart', { tallas: st.e.join(',') });
      ocupado = false;
      if (cta) cta.disabled = false;
      if (aviso) { aviso.textContent = 'Listo · tu pack está en la bolsa'; aviso.classList.remove('is-mal'); }
      try {
        window.dispatchEvent(new CustomEvent('cart47:refresh'));
        window.dispatchEvent(new CustomEvent('cart47:open'));
      } catch (e) {}
    }).catch(function () {
      ocupado = false;
      if (cta) cta.disabled = false;
      if (aviso) {
        aviso.textContent = 'No se pudo agregar. Revisa tu conexión e inténtalo de nuevo';
        aviso.classList.add('is-mal');
      }
    });
  }

  if (cta) cta.addEventListener('click', comprar);

  /* La barra fija ahora es el componente compartido cro47-sticky, que
     espeja este mismo botón. Se quitó la de aquí para no tener dos. */

  /* ── una talla para todo el pack ────────────────────────────────────────
     Vive DENTRO de este controlador a propósito: comparte `cards` y `pinta`,
     así que el progreso, el CTA y la barra fija se enteran solos.

     OJO con lo que se pliega y lo que no: las FOTOS y el nombre de cada
     prenda se quedan siempre a la vista, porque son la prueba de qué trae el
     pack. Lo único que se oculta son los botones de talla, y en su lugar la
     ficha muestra la talla que le tocó. */
  var una = raiz.querySelector('[data-p6x47-una]');
  var grid = raiz.querySelector('#p6x47-rejilla') || raiz.querySelector('.p6x47__grid');
  var abrir = raiz.querySelector('[data-p6x47-abrir]');
  var unaAv = raiz.querySelector('[data-p6x47-una-av]');
  var modoSimple = false;

  function filas(card) { return card.querySelector('[data-p6x47-tallas]'); }
  function etiq(card) { return card.querySelector('[data-p6x47-card-t]'); }

  function pliega(si) {
    modoSimple = si;
    for (var i = 0; i < cards.length; i++) {
      var f = filas(cards[i]), e = etiq(cards[i]);
      if (f) f.hidden = si;
      if (e) e.hidden = !si;
    }
    if (abrir) { abrir.hidden = !si; abrir.setAttribute('aria-expanded', si ? 'false' : 'true'); }
  }

  /* Muestra en cada ficha la talla que quedó, o avisa si esa no había */
  function marcaFichas(talla) {
    for (var i = 0; i < cards.length; i++) {
      var e = etiq(cards[i]);
      if (!e) continue;
      var puesta = cards[i].querySelector('.p6x47__talla.is-on');
      if (puesta) {
        e.textContent = 'Talla ' + puesta.getAttribute('data-p6x47-talla');
        e.classList.remove('is-mal');
      } else {
        e.textContent = 'Sin ' + talla + ' · elige otra';
        e.classList.add('is-mal');
      }
    }
  }

  function abreUna(card) {
    pliega(false);
    if (card) {
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      card.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'center' });
    }
  }

  if (una && grid) {
    pliega(true);

    una.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('[data-p6x47-una-t]') : null;
      if (!b) return;
      ev.preventDefault();
      var talla = b.getAttribute('data-p6x47-una-t');

      var todos = una.querySelectorAll('[data-p6x47-una-t]');
      for (var i = 0; i < todos.length; i++) {
        var on = todos[i] === b;
        todos[i].classList.toggle('is-on', on);
        todos[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      /* Se aplica ficha por ficha respetando el stock real. La que no tenga
         esa talla se nombra: fallar callado aquí es un carrito rechazado. */
      var faltan = [], primeraMal = null;
      for (var c = 0; c < cards.length; c++) {
        var hermanos = cards[c].querySelectorAll('[data-p6x47-talla]');
        var destino = cards[c].querySelector('[data-p6x47-talla="' + talla + '"]:not([disabled])');
        for (var k = 0; k < hermanos.length; k++) {
          var sel = destino && hermanos[k] === destino;
          hermanos[k].classList.toggle('is-on', !!sel);
          hermanos[k].setAttribute('aria-pressed', sel ? 'true' : 'false');
        }
        if (!destino) {
          faltan.push(cards[c].getAttribute('data-p6x47-nombre') || ('#' + (c + 1)));
          if (!primeraMal) primeraMal = cards[c];
        }
      }

      marcaFichas(talla);

      if (unaAv) {
        if (faltan.length) {
          unaAv.classList.remove('is-ok');
          unaAv.textContent = (cards.length - faltan.length) + ' de ' + cards.length + ' en ' + talla +
            ' · ' + faltan.join(', ') + (faltan.length === 1 ? ' no tiene esa talla' : ' no tienen esa talla') +
            ', elige otra abajo';
          abreUna(primeraMal);
        } else {
          unaAv.classList.add('is-ok');
          unaAv.textContent = 'Las ' + cards.length + ' en talla ' + talla;
        }
      }
      pinta();
    }, false);
  }

  if (abrir) abrir.addEventListener('click', function () { abreUna(null); });

  /* ── arranque ─────────────────────────────────────────────────────────── */
  if (cfg.pre_talla) {
    for (var c = 0; c < cards.length; c++) {
      var b = cards[c].querySelector('[data-p6x47-talla="' + cfg.pre_talla + '"]:not([disabled])');
      if (b) { b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); }
    }
  }
  pinta();

  if ('IntersectionObserver' in window) {
    var visto = false;
    var io3 = new IntersectionObserver(function (en) {
      for (var i = 0; i < en.length; i++) {
        if (en[i].isIntersecting && !visto) { visto = true; eventoUnaVez('pack_viewed'); io3.disconnect(); }
      }
    }, { threshold: 0.25 });
    io3.observe(raiz);
  }
})();
